// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__sZ-Mm","title":"Images90_title__3XlA1","images":"Images90_images__2ytPY"};